var map = {
	"./markPoint1.png": "5a17",
	"./markPoint10.png": "108c",
	"./markPoint2.png": "902f",
	"./markPoint3.png": "0799",
	"./markPoint4.png": "5700",
	"./markPoint5.png": "f55b",
	"./markPoint6.png": "e5f3",
	"./markPoint7.png": "f23a",
	"./markPoint8.png": "5af5",
	"./markPoint9.png": "d4be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "257a";